import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

import fetchThreads from 'mewe/fetchers/fetch-threads';
import { ChatFilter } from 'mewe/constants';

export default class MwChatFilters extends Component {
  @service chat;

  ChatFilter = ChatFilter;

  @action
  changeFilter(filter) {
    this.args.updateChatFilter(filter);
    this.chat.writeChatFilter(filter);
    fetchThreads({ chatType: filter });
  }
}
